import {remCalc} from '../../_utils'

export default {
    baseStyle: ({
        isSmallTablet,
        slidersLength,
        hasPaddings,
    }: {
        isSmallTablet: boolean
        slidersLength: number
        hasPaddings: boolean
    }) => ({
        container: {
            maxW: remCalc(1920),
            mx: 'auto',
            py: hasPaddings ? {base: remCalc(24), md: remCalc(24), lg: remCalc(40)} : 'unset',
            width: '100%',
            '& > .swiper': {
                maxWidth: remCalc(1920),
            },
            '.promo-slider-pagination': {
                display: 'flex !important',
                alignItems: 'center',
                justifyContent: 'center',
                gap: remCalc(8),
                mt: remCalc(16),
                paddingTop: '0 !important',
                width: 'fit-content !important',
                marginInline: 'auto',
                position: 'relative',
            },
            '.promo-slider-pagination .swiper-pagination-bullet': {
                width: remCalc(6),
                height: remCalc(6),
                borderRadius: 'full',
                opacity: 1,
                backgroundColor: 'background.base.deep',
                margin: '0 !important',
            },
            '.promo-slider-pagination .swiper-pagination-bullet-active': {
                width: remCalc(12),
                backgroundColor: 'background.strong.default',
            },
        },
        chevronIcon: {
            width: remCalc(36),
            height: remCalc(36),
            position: 'absolute',
            color: 'foreground.neutral.inverse',
            bg: 'background.base.overlay',
            boxShadow: 'borderShadow',
            backdropFilter: 'blur(5px)',
            border: 'small',
            borderColor: 'border.neutral.highlight',
            borderStyle: 'solid',
            borderRadius: 'full',
            transform: 'translateY(-100%)',
            cursor: 'pointer',
            zIndex: '10',
            top: isSmallTablet ? '53%' : {base: '52%', md: '53%'},
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            _after: {
                content: 'none',
                display: 'none',
            },
        },
        outterCardContainer: {
            paddingLeft: {base: remCalc(16), md: remCalc(24), lg: 0}, //isSmallTablet ? remCalc(16) :
            paddingRight:
                slidersLength < 3
                    ? isSmallTablet
                        ? remCalc(16)
                        : {md: remCalc(16), lg: remCalc(0)}
                    : '',
        },
        cardContainer: {
            overflow: 'hidden',
            bgSize: 'cover',
            bgPos: 'center',
            bgRepeat: 'no-repeat',
            w: '100%',
            height: isSmallTablet ? remCalc(410) : {base: remCalc(400), md: remCalc(560)},
            position: 'relative',
            cursor: 'auto',
        },
        textContentContainer: {
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-end',
            w: '100%',
            padding: isSmallTablet ? remCalc(24) : {base: remCalc(24), md: remCalc(40)},
        },
        moodboardButton: {
            variant: 'link-button',
            color: 'foreground.neutral.inverse',
        },
        moodboardTextTitleDescription: {
            mb: {base: remCalc(16), md: remCalc(16), lg: remCalc(16), xl: remCalc(24)},
            titleSpacing: {
                base: remCalc(16),
                md: remCalc(16),
                lg: remCalc(16),
                xl: remCalc(24),
            },
            textStyle: 'head-small',
            color: 'foreground.neutral.inverse',
            fontWeight: 'medium',
            childrenTextStyle: 'body-medium',
            childrenTextColor: 'foreground.neutral.inverse',
            _focusVisible: {
                border: 'large',
                borderStyle: 'solid',
                borderColor: 'button.border.accessibility-blue-dark',
                outline: 'unset',
            },
        },
        moodboardChevronIcon: {
            color: 'inherit',
            pointerEvents: 'none',
        },
        moodboardButtonText: {
            color: 'inherit',
            textStyle: 'body-medium',
        },
        moodboardButtonStack: {
            gap: remCalc(10),
            textDecoration: 'none',
        },
    }),
}
